import type {
  BatchUploadOutputs,
  BatchUploadStepId,
  BatchUploadWorkflowEvent,
  CreateWorkOrdersOutput,
  PlanAppointmentsOutput,
} from "../_shared/_logic/batch-upload-contract"
import { validateBatchUploadPropertyLimit } from "../_shared/_logic/batch-upload-limits"

export const hasUsableCreateWorkOrdersOutput = (output?: CreateWorkOrdersOutput | null) =>
  Boolean(
    output?.createdRows?.length &&
    output.createdRows.length === output.selectedRows.length &&
    !validateBatchUploadPropertyLimit(output.selectedRows.map((row) => row.propertyId)),
  )

export const hasUsablePlanningOutput = (output?: PlanAppointmentsOutput | null) =>
  Boolean(output && output.plannedRows.length > 0)

export const canEnterBatchUploadStep = (outputs: BatchUploadOutputs, step: BatchUploadStepId) => {
  if (step === "load_list") return true

  if (step === "plan_appointments") return hasUsableCreateWorkOrdersOutput(outputs.loadList)

  if (step === "contact_orders") return Boolean(outputs.planAppointments?.createdEvents.length)

  if (step === "results") return Boolean(outputs.planAppointments)

  return false
}

export const completedBatchUploadStepIndex = (outputs: BatchUploadOutputs) => {
  if (outputs.contactOrders) return 2

  if (outputs.planAppointments) return 1

  if (outputs.loadList) return 0

  return -1
}

export const applyBatchUploadEvent = (
  outputs: BatchUploadOutputs,
  event: BatchUploadWorkflowEvent,
): BatchUploadOutputs => {
  switch (event.type) {
    case "load_list_completed":
      return {
        loadList: event.output,
      }
    case "planning_progress":
      return { ...outputs, planningProgress: event.output }
    case "planning_completed":
      return {
        ...outputs,
        planAppointments: event.output,
        planningProgress: undefined,
        contactOrders: undefined,
      }
    case "planning_changed":
      return {
        ...outputs,
        contactOrders: undefined,
      }
    case "contact_orders_completed":
      return {
        ...outputs,
        contactOrders: event.output,
      }
    default:
      return outputs
  }
}

export const invalidStepMessage = (outputs: BatchUploadOutputs, step: BatchUploadStepId) => {
  if (step === "plan_appointments")
    return (
      validateBatchUploadPropertyLimit(
        outputs.loadList?.selectedRows.map((row) => row.propertyId) ?? [],
      ) ?? "Bitte zuerst Aufträge anlegen."
    )

  if (step === "contact_orders")
    return outputs.loadList ? "Bitte zuerst Termine planen." : "Bitte zuerst Aufträge anlegen."

  if (step === "results") return outputs.planAppointments ? null : "Bitte zuerst Termine planen."

  return null
}
